
export default function CardComponent(props) {

    return ( 


<div className='row align-items-center justify-content-center'>
<div className="col-lg-6 col-md-8 col-sm-12 col-xs-12 col">
    <div className='card'>
        <div className="card-header bg-primary h4">
            {props.title}
        </div>
        <div className="card-body">
            <ul className="list-group">
                <li className="list-group-item" >This site is known to have some issues with some browsers. If you are having issues, please try <a target="_blank" rel="noreferrer" href="https://www.google.com/chrome/">Chrome</a> or <a target="_blank" rel="noreferrer" href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>.</li>
                <li className="list-group-item" >As you select files, they will be dynamically loaded and checked.</li>
            </ul>
            <hr className='mt-3 bg-sucess' />
            {props.children}
            <div className="card border-info mb-3">
                <div className="card-header">Status</div>
                <div className="card-body" id="statusnotediv">
                {
                    props.status.map((entry, index)=>{
                    let colorclass = entry.type || "text-muted";
                    if (colorclass === "text-muted") return null;
                    return (
                        <small key={index} className={"form-text " + colorclass} >{entry.msg}</small>
                    );
                    })
                }  
                </div>
            </div>
        </div>
    </div>
</div>
</div>
);
}